/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementSettingEventReDrawResponse } from './EventManagementSettingEventReDrawResponse';

export type EventManagementSettingEventReDrawResponseApiRespoonse = {
    data?: EventManagementSettingEventReDrawResponse;
    status?: EventManagementSettingEventReDrawResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementSettingEventReDrawResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

